/**
 * Returns display label + color for a job based on status & closedByEmployer flag.
 *
 * PENDING_APPROVAL        → Gözləyir     (yellow/amber)
 * ACTIVE                  → Aktiv        (green)
 * REJECTED                → Rədd edildi  (orange/red)
 * CLOSED + !closedByEmployer → Tamamlanıb  (cyan/info) — enough workers found
 * CLOSED + closedByEmployer  → İmtina      (red)        — employer cancelled
 */
export function jobStatusLabel(job) {
  if (job.status === 'PENDING_APPROVAL') {
    return { text: 'Gözləyir', color: '#f59e0b', bg: 'rgba(245,158,11,.12)', border: 'rgba(245,158,11,.3)' }
  }
  if (job.status === 'ACTIVE') {
    return { text: 'Aktiv', color: 'var(--success)', bg: 'rgba(52,211,153,.12)', border: 'rgba(52,211,153,.25)' }
  }
  if (job.status === 'REJECTED') {
    return { text: 'Rədd edildi', color: '#f97316', bg: 'rgba(249,115,22,.12)', border: 'rgba(249,115,22,.3)' }
  }
  if (job.status === 'CLOSED' && !job.closedByEmployer) {
    return { text: 'Tamamlanıb', color: 'var(--info)', bg: 'rgba(96,165,250,.12)', border: 'rgba(96,165,250,.25)' }
  }
  // CLOSED + closedByEmployer
  return { text: 'İmtina', color: 'var(--danger)', bg: 'rgba(248,113,113,.12)', border: 'rgba(248,113,113,.25)' }
}
